<div class="users-permission-assignments-container">
    <div fxLayout="row" fxLayoutAlign="center">
        <h2 class="mat-h2 text-primary">{{'Permission assignments for users'|i18n}}</h2>
    </div>
    <div fxLayout="row" fxLayoutAlign="start" class="mb-24">
        <button mat-icon-button [title]="'Back to permission management'|i18n"
                (click)="onClickGotoPermissionMgmt()">
            <app-icon name="fal-arrow-circle-left" class="back-button"></app-icon>
        </button>
    </div>
    <lib-user-table [capabilities]="{canUpdate: false, canDelete: false}"
                    [selectable]="true" [detailsOnSelect]="false"
                    [selectedRowStyle]="{'background-color': SELECTED_USER_COLOR}"
                    [pageSize]="5" [pageSizeOptions]="[5, 10, 15]"
                    [filter]="userFilter"
                    (selected)="onSelectUser($event)">
    </lib-user-table>
    <div *ngIf="!user" fxLayout="row" fxLayoutAlign="center">
        {{'Please select a user'|i18n}}
    </div>
    <ng-container *ngIf="user">
        <ng-container *ngIf="assignments; else loadingAssignments">
            <app-permission-assignments *ngIf="assignments.length"
                                        [readOnly]="true"
                                        [hideSubject]="true"
                                        [assignments]="assignments">
            </app-permission-assignments>
        </ng-container>
    </ng-container>
</div>

<ng-template #loadingAssignments>
    <div fxLayout="row" fxLayoutAlign="center" class="mt-24 mb-16">
        <mat-spinner diameter="20"></mat-spinner>
        <span class="pl-8">{{'Loading permission assignments'|i18n}}...</span>
    </div>
</ng-template>
